import { useQuery } from '@tanstack/react-query'

import { fetchHighlightedBrands } from 'api/fetchers/fetchHighlightedBrands'

export const useHighlightedBrands = () =>
  useQuery({
    queryKey: ['highlightedBrands'],
    queryFn: async ({ signal }) => (await fetchHighlightedBrands()(signal)).data,
    select: data => data.data,
  })
